<template>
	<div class="activity">
		<div class="left">
			<div class="images">
				<img
					:src="getImage(index)"
					class="image"
					:class="{visible: isVisible(index)}"
					v-for="index in gallery"
					:key="index"
				>
				<video
					loop
					autoplay
					muted
					:src="videoUrl"
					v-if="afisha"
					class="video"
					:class="{visible: isVisible(gallery + 1)}"
				></video>
			</div>
			<div class="gradient"></div>
			<template v-if="slider">
				<div class="arrow-left" @click="goLeft"></div>
				<div class="arrow-right" @click="goRight"></div>
			</template>
		</div>
		<div class="right">
			<div class="inner" :style="{paddingBottom: footerHeight}">
				<div class="scroll">
					<div class="back" @click="goBack">
						<img src="@/assets/arrow-back.png">
						Вернуться
					</div>
					<div class="afisha" v-if="afisha">Тестирует «Афиша»</div>
					<div class="title">{{ title }}</div>
					<div class="text">{{ text }}</div>
				</div>
			</div>
		</div>
		<div class="more" :style="{height: footerHeight}">
			<div class="wrap">
				<div class="title">больше способов #боржомить</div>
				<div class="cards">
					<router-link
						class="card"
						@click="goMore(card)"
						v-for="card in more"
						:to="cardLink(card)"
						:key="card.id"
					>
						<img :src="cardImage(card)">
						<div class="card-title">{{ card.title }}</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { CARDS } from '@/config'

export default {
	data() {
		return {
			id: 1,
			footerHeight: '255px',
			galleryIndex: 1,
			view: null,
		}
	},
	computed: {
		afisha() {
			return CARDS[this.id].afisha
		},
		title() {
			return CARDS[this.id].title
		},
		text() {
			return CARDS[this.id].full
		},
		slider() {
			return this.gallery > 1
		},
		gallery() {
			return CARDS[this.id].gallery
		},
		videoUrl() {
			return require(`@/assets/videos/${this.id + 1}.mp4`)
		},
		more() {
			let next = CARDS.slice(this.id + 1, this.id + 4)
			if (next.length < 3) {
				let off = 3 - next.length
				return [...next, ...CARDS.slice(0, off)]
			} else {
				return next
			}
		},
	},
	created() {
		this.id = parseInt(this.$route.params.id) - 1
		window.addEventListener('resize', this.calcFooter)
		this.calcFooter()
		this.view = document.getElementById('view')
	},
	destroyed() {
		window.removeEventListener('resize', this.calcFooter)
	},
	mounted() {
		this.view.scrollTop = 0
	},
	watch: {
		$route() {
			this.id = parseInt(this.$route.params.id) - 1
			this.view.scrollTop = 0
			this.galleryIndex = 1
		},
	},
	methods: {
		isVisible(index) {
			return this.galleryIndex === index
		},
		getImage(index) {
			return require(`@/assets/${this.id + 1}/${index}.jpg`)
		},
		calcFooter() {
			let width = window.innerWidth
			let res = Math.floor(width / 5)
			if (width < 750) return (this.footerHeight = 'auto')
			this.footerHeight = res + 'px'
		},
		cardLink(card) {
			return '/activity/' + card.id
		},
		cardImage(card) {
			return require(`@/assets/${card.id}/1s.jpg`)
		},
		goLeft() {
			ga('send', 'event', this.title, 'gallery-left')
			if (this.afisha) {
				if (this.galleryIndex === 1) return (this.galleryIndex = this.gallery + 1)
			} else {
				if (this.galleryIndex === 1) return (this.galleryIndex = this.gallery)
			}
			return (this.galleryIndex -= 1)
		},
		goRight() {
			ga('send', 'event', this.title, 'gallery-right')
			if (this.afisha) {
				if (this.galleryIndex === this.gallery + 1) return (this.galleryIndex = 1)
			} else {
				if (this.galleryIndex === this.gallery) return (this.galleryIndex = 1)
			}
			return (this.galleryIndex += 1)
		},
		goMore(card) {
			this.galleryIndex = 1
			ga('send', 'event', 'more', 'from ' + this.title, 'to ' + CARDS[card.id].title)
		},
		goBack() {
			ga('send', 'event', 'back', 'from ' + this.title)
			this.$router.push('/')
		},
	},
}
</script>


<style lang="less" scoped>
.activity {
	width: 100%;
	height: 100%;
	display: flex;
}

.left {
	width: 50vw;
	height: 100vh;
	overflow: hidden;
	position: relative;

	.images {
		height: 100%;
		position: relative;
		left: 50%;
		transform: translateX(-50%);

		.image {
			height: 100%;
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			opacity: 0;
		}

		.image.visible {
			opacity: 1;
		}

		.video {
			height: 100%;
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			opacity: 0;
		}

		.video.visible {
			opacity: 1;
		}
	}

	.gradient {
		width: 100%;
		height: 50vh;
		position: absolute;
		left: 0;
		bottom: 0;
		background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
	}

	.arrow-left {
		width: 30px;
		height: 60px;
		position: absolute;
		top: 50%;
		left: 0;
		background-image: url('../assets/arrow-left.png');
		cursor: pointer;
	}

	.arrow-right {
		width: 30px;
		height: 60px;
		position: absolute;
		top: 50%;
		right: 0;
		background-image: url('../assets/arrow-right.png');
		cursor: pointer;
	}
}

.right {
	width: 50vw;
	height: 100vh;
	overflow: hidden;
	overflow-y: auto;

	.inner {
		padding: 0 5vw;
		margin-top: 80px;
		overflow: auto;
	}

	.scroll {
		display: flex;
		flex-direction: column;
		text-align: left;
	}

	.back {
		opacity: 0.5;
		font-size: 12px;
		text-transform: uppercase;
		padding: 10px 0;
		cursor: pointer;
		opacity: 0.7;
		transition: all 200ms ease;
		color: #fff;
		text-decoration: none;

		&:hover {
			opacity: 1;
		}

		img {
			width: 24px;
			margin-right: 5px;
			display: inline-block;
		}
	}

	.afisha {
		color: #6df9fa;
		text-transform: uppercase;
		font-size: 14px;
		font-weight: bold;
		padding-bottom: 10px;
	}

	.title {
		text-transform: uppercase;
		font-size: 46px;
		line-height: 50px;
	}

	.text {
		margin-top: 30px;
		font-size: 18px;
		padding-bottom: 20px;
	}
}

.more {
	width: 100%;
	position: absolute;
	bottom: 0;
	background-image: url('../assets/activity_footer.png');
	background-size: cover;
	background-position: center bottom;

	.wrap {
		position: absolute;
		left: 50%;
		bottom: 20px;
		transform: translateX(-50%);
	}

	.title {
		font-size: 28px;
		text-transform: uppercase;
		margin-bottom: 20px;
	}

	.cards {
		width: 500px;
		display: flex;
		justify-content: space-between;
	}

	.card {
		width: 140px;
		color: #fff;
		text-decoration: none;

		img {
			width: 140px;
			height: 90px;
			transition: all 300ms ease;
		}

		.card-title {
			font-size: 14px;
			text-transform: uppercase;
			margin-top: 10px;
			height: 50px;
		}
	}

	.card:hover {
		img {
			transform: translateY(-5px);
		}
	}
}

@media only screen and (max-device-width: 640px),
	only screen and (max-device-width: 736px),
	only screen and (max-width: 480px) {
	.activity {
		width: 100%;
		height: auto;
		display: flex;
		flex-direction: column;
	}

	.left {
		width: 100%;
		height: 70vh;
	}

	.right {
		width: 100%;
		height: auto;

		.inner {
			padding: 0 20px;
			margin-top: 30px;
		}

		.title {
			font-size: 30px;
			line-height: 32px;
		}
	}

	.more {
		position: relative;
		height: auto;
		background-size: 100vw;
		background-repeat: no-repeat;
		background-position: center bottom;
		margin-top: 50px;

		.wrap {
			position: relative;
		}

		.cards {
			width: 100%;
			flex-direction: column;
			justify-content: space-around;
			align-items: center;

			.card-title {
				height: 80px;
			}
		}
	}
}
</style>